import * as React from 'react';
import * as ReactRouter from 'react-router';
import * as queryString from 'query-string';

import './login.scss';
import { getLoginDefaultValues, LoginState, QueryProps } from './LoginForm/loginFormUtils';
import { linkToSignup } from '../Common/Footer/footerConfigs';
import * as routerState from 'login-utils/routerState';
import AppDocumentWrapper from './FormComponents/AppDocumentWrapper';
import LoginForm from './LoginForm/OldLoginForm';

class OldLogin extends React.Component<ReactRouter.RouteComponentProps<{}, {}>, LoginState> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const success = routerState.getOnce('success');
    this.setState({
      successMessage: success,
    });
  }

  render() {
    const { location } = this.props;
    const queryProps = queryString.parse(location.search) as QueryProps;
    const { errorMsg, successMsg } = getLoginDefaultValues(queryProps, this.state.successMessage);
    return (
      <div className="Login" id="it-Login">
        <AppDocumentWrapper footerConfig={linkToSignup}>
          <LoginForm errorMsg={errorMsg} successMsg={successMsg} />
        </AppDocumentWrapper>
      </div>
    );
  }
}

export default OldLogin;
